import { render, staticRenderFns } from "./ModalConsignmentWeight.vue?vue&type=template&id=8c166790&"
import script from "./ModalConsignmentWeight.vue?vue&type=script&lang=js&"
export * from "./ModalConsignmentWeight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports